<app-header *ngIf="!isNoHeaderRoute()" class="h-20 fixed top-0 left-0 w-full z-10"></app-header>
<main *ngIf="!isNoHeaderRoute(); else notHeader" class="pt-20 min-h-screen" style="box-sizing: border-box;">
  <router-outlet *ngIf="!isNoHeaderRoute();"></router-outlet>
</main>

<ng-template #notHeader>
  <router-outlet *ngIf="isNoHeaderRoute();"></router-outlet>
</ng-template>


